import { Box, Drawer, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

import { lightTheme } from '../lib/theme';
import { ModalButton } from './modalButton';

const { button } = lightTheme.components;

interface ConfirmationBottomSheetProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  cancelButtonLabel?: string;
  confirmButtonLabel: string;
  confirmButtonStyle?: React.CSSProperties;
  onOption?: () => void;
  optionButtonLabel?: string;
  optionButtonStyle?: React.CSSProperties;
  children: React.ReactNode;
}

export const ConfirmationBottomSheet = ({
  open,
  onClose,
  onConfirm,
  cancelButtonLabel = 'Отменить',
  confirmButtonLabel,
  confirmButtonStyle,
  onOption,
  optionButtonLabel,
  optionButtonStyle,
  children,
}: ConfirmationBottomSheetProps) => {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      variant="temporary"
      PaperProps={{
        style: {
          maxHeight: 'calc(85vh - env(safe-area-inset-bottom))',
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          paddingBottom: 'env(safe-area-inset-bottom)',
        },
      }}
    >
      <Box
        className="design-v3-font"
        paddingX="20px"
        paddingTop="12px"
        paddingBottom="max(24px, env(safe-area-inset-bottom))"
        style={{
          overflowY: 'auto',
          maxHeight: 'calc(85vh - env(safe-area-inset-bottom) - 60px)',
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          marginBottom="16px"
          position="relative"
        >
          <Box
            width={40}
            height={4}
            borderRadius={2}
            bgcolor="rgba(0,0,0,0.2)"
            style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          />
          <Box flexGrow={1} />
          <IconButton
            onClick={onClose}
            size="small"
            style={{
              padding: 8,
            }}
          >
            <CloseIcon style={{ fontSize: 20 }} />
          </IconButton>
        </Box>

        <Box fontSize={20} fontWeight={600} marginBottom="24px" color="#181F28">
          {children}
        </Box>

        {optionButtonLabel && onOption ? (
          <Box display="flex" flexDirection="column" gridGap="8px">
            <ModalButton
              label={confirmButtonLabel}
              onClick={onConfirm}
              style={{
                background: button.primary.accent.bg,
                color: button.primary.accent.label,
                border: null,
                width: '100%',
                height: 48,
                ...confirmButtonStyle,
              }}
            />
            <ModalButton
              label={optionButtonLabel}
              onClick={onOption}
              style={{
                background: button.primary.neutral.bg,
                color: button.primary.neutral.label,
                border: null,
                width: '100%',
                height: 48,
                ...optionButtonStyle,
              }}
            />
            <ModalButton
              label={cancelButtonLabel}
              onClick={onClose}
              style={{
                width: '100%',
                height: 48,
              }}
            />
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gridGap="8px">
            <ModalButton
              label={confirmButtonLabel}
              onClick={onConfirm}
              style={{
                background: button.primary.accent.bg,
                color: button.primary.accent.label,
                border: null,
                width: '100%',
                height: 48,
                ...confirmButtonStyle,
              }}
            />
            <ModalButton
              label={cancelButtonLabel}
              onClick={onClose}
              style={{
                width: '100%',
                height: 48,
              }}
            />
          </Box>
        )}
      </Box>
    </Drawer>
  );
};
